import url from './url';



export default url(({ searchParams }) => `/templates${searchParams ? `?${searchParams}` : ''}`);
